<template>
    <div  v-if="info">
        <Down v-if="isWeixins()" />
        <div :class="{'daily-list-panel':true,'iswx':isWeixins()}">
            <div v-if="$route.query.h" class="tab-test" :style="{'width': '100%','height': $route.query.h /100 + 'rem'}"></div>
            <div :class="{'daily-pro':true,'intelligence':false}">
                <!-- 可可爱爱没有脑袋 -->
                <Header :behavior="behavior" :type="type" :info="info" :buy_info="buy_info" />
                <div :class="{'daily-switch':true, 'none':false}">
                    <div>
                        <span :class="{'current':true,'isSelect':isSelect == 1}" @click="switchTab(1)" >历史推荐<em></em></span>
                    </div>
                    <div>
                        <span :class="{'current':true,'isSelect':isSelect == 2}" @click="switchTab(2)" >今日推荐<em></em></span>
                    </div>
                    <div>
                        <span :class="{'current':true,'isSelect':isSelect == 3}" @click="switchTab(3)" >明日预告<em></em></span>
                    </div>
                </div>
            </div>
            <!-- {/* 日历切换 */} -->
            <div :class="{'daily-calendar':true,'none':type==6 || type==19 || type == 20 || (type==18&&modelActive==2) || (type==17&&modelActive==2) || (type==15&&modelActive==2)||(type==21&&modelActive==2)||(type==22&&modelActive==2)}">
                <template v-if="getCookies('JH') && info.status != 0 && info.status != 3 && tomorrow_num  > 0">
                     <i class="matchs-line"></i><b>预告明日{{tomorrow_num}}场比赛</b>
                </template>
                <div :class="{'matchs-num':true,'none':type==18 || type==17 || type==16 || type==15||type==21||type==22}">{{daytxt}}{{current_time}}(共{{today.length}}场) <i :class="{'icon':true,'i_calendar':true,'none':isSelect!=1}" @click="showCalendar = true"></i></div>
                <!-- {/* 冷门等模型 */} -->
                <!-- <div :class="{'matchs-num':true,'none':type!=18 && type!=17 && type!=16 && type!=15&&type!=21&&type!=22 || ((type==16||type==15||type==21||type==22)&&modelActive==2&&(info.status==0||info.status==-1||info.status==3))}"><span :class="{'none':!(type==16&&modelActive==2)}">今日</span>{{coldtime}}(共{{coldList && coldList.length}}场) <i :class="{'icon':true,'i_calendar':true,'none':type==16&&modelActive==2}" @click="showCalendar = true"></i></div> -->
            </div>
             <!-- 可可爱爱没有身体 -->
            <div :class="{'daily-list': true, 'bg1': !(today.length === 0), 'none': loading}">
                <div class="daily-package daily-2 nobg">
                    <ul>
                        <li class="daily-package-item no1">
                            <template v-if="today.length > 0">
                                <div v-for="(item,index) in today" :key="index" class="package-dec dec_1" @click="goMatchLive">
                                    <div class="package-team info">
                                        <span class="league" :style="{color: item.sclass_color}">{{item.sclass_name}}</span><span class="time">{{item.match_time.replace(/(^\d{4}\-|\:\d{2}$)/g, "").replace(/\-(\d{2})/g, "月$1日")}}</span>
                                    </div>
                                    <div class="package-team sub">
                                        <template v-if="item.type == '4'">
                                            <strong v-if="item.show_team == '1'">{{item.home_team}}</strong>
                                            <strong v-else>{{item.guest_team}}</strong>
                                        </template>
                                        <template v-else>
                                            <strong>{{item.home_team}}<span>{{item.homeWholeGoals ? item.homeWholeGoals+':'  : ''}}{{item.awayWholeGoals || ''}}</span>{{item.guest_team}}</strong>
                                        </template>
                                    </div>
                                    <div :class="{'package-team': true, 'des': true, 'limit': item.type == '4'}">
                                        <template v-for="(is,ins) in item.text.split('!')">
                                            <p :key="ins">{{item.text.split("!")[ins]}}</p>
                                        </template>
                                        <p v-if="item.type == '3' || item.type == '5'" class="odds">注：欧指指数来自365</p>
                                    </div>
                                    <RenderChar :item="item" />
                                </div>
                            </template>
                            <template v-else>
                                <template v-if="isSelect == 1">
                                    <div class="daily-find">
                                        <i class="daily-no-find"></i>
                                        <p>暂无数据!</p>
                                    </div>
                                </template>
                                <template v-else>
                                    <template v-if="info.status == 0 || info.status == -1 || info.status == 3">
                                        <div class="daily-find">
                                            <i class="daily-no-find"></i>
                                            <p>您目前暂未订购该模型，仅可查看往日推荐内容，<span class="gonow" @click="go_daily_buy(type, false)">赶快去订购吧！</span></p>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="daily-find">
                                            <i class="daily-no-find"></i>
                                            <p>暂无数据!</p>
                                        </div>
                                    </template>
                                </template>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
            <Calendar
                :show="showCalendar"
                :start_time="start_time"
                :end_time="end_time"
                :current_time="current_time"
                @callback="updateDailyDate"
            />
        </div>
    </div>
</template>

<script>
import Down from "../../components/programme/appdown.vue"
import Header from "../../components/modelTemporary/header.vue"
import { isWeiXin, setTitle, formatDate, getCookie, isJHAppios, getAppV, doLogin, isStorepack, gotourl, goMatchLive, isJHApp } from "../../utils/base"
import { getDataTypeListApi } from "../../api/modelTemporary"
// import { shareinit } from "../../utils/share"
import Calendar from "../../components/datamodel/common/calendar.vue"
import RenderChar from "../../components/datamodel/common/renderSvg.vue"
import mutil from "../../utils/mutil"
export default {
    name: "matchIntroduce",
    components: {
        Down,
        Header,
        Calendar,
        RenderChar
    },
    data () {
        return {
            isSelect: 1,
            behavior: this.$route.query.behavior || "", // 新人注册？？
            type: this.$route.query.type || 1,
            time: this.$route.query.time || "",
            info: null,
            buy_info: {
                total: 0, // 购买数据用户列表
                avatar: [] // 购买数据总人数
            },
            closeAi: false,
            today: [], // 默认数据
            tomorrow_num: 0, // 预计明日
            current_time: '',
            start_time: '',
            end_time: "",
            daytxt: "",
            coldtime: "",
            showCalendar: false
        }
    },
    created () {
        this.getDataTypeList()
    },
    methods: {
        go_daily_buy (type, renewals) {
            var iosNeedLogin = this.$route.query.ios_need_login * 1 || 0;
            if ((isJHAppios() && getAppV() >= 342) || (this.hiscores && !iosNeedLogin)) {
                // ios V>=342
                // hiscores 不强制登录
            } else {
                if (this.nologin) {
                    doLogin();
                    return;
                }
            }
            // ios商城包自动续费已开通
            if (this.onlineIsAuto && !isStorepack()) {
                // window.swal({
                //     type: "alert",
                //     title: "温馨提示",
                //     confirmTitle: "我知道了",
                //     detail: "您已开通了自动续费功能，需要到苹果设备上取消续费后才能再次购买哦~ 取消方法：通过手机【设置】进入【iTunes Store与App Store】>>选择【Apple ID】>>点击【查看Apple ID】>>在账户设置页面点击【订阅管理】>>取消即嗨" + (dataTitleList[type]) + "数据的订阅即可。"
                // })
                return;
            }
            let url = ""
            if (isJHAppios() || !isJHApp()) {
                url = '/page/new_pay?ordertype=pay_data&type=' + type;
            } else {
                url = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + type;
            }
            if (renewals) {
                url += "&renewals=1"
            }
            gotourl(url);
        },
        goMatchLive (matchId) {
            goMatchLive(matchId);
        },
        getCookies (key) {
            return getCookie(key)
        },
        // 切换日历
        updateDailyDate (year, month, day) {
            window.sessionStorage.setItem("savedate", "");
            this.showCalendar = false
            this.loading = true
            this.getDataTypeList(year, month, day);
        },
        closeCalendar () {
            this.showCalendar = false
        },
        //  tab切换
        switchTab (num) {
            this.isSelect = num
            var year, month, day;
            // 获取今日年月日
            year = new Date().getFullYear();
            month = new Date().getMonth() + 1;
            day = new Date().getDate();
            // 前一天毫秒
            var preSecond = new Date(year + "/" + month + "/" + day).getTime() - 86400000;
            // 后一天毫秒
            var nextSecond = new Date(year + "/" + month + "/" + day).getTime() + 86400000;

            if (num === 1) {
                year = new Date(preSecond).getFullYear();
                month = new Date(preSecond).getMonth() + 1;
                day = new Date(preSecond).getDate();
            } else if (num === 3) {
                year = new Date(nextSecond).getFullYear();
                month = new Date(nextSecond).getMonth() + 1;
                day = new Date(nextSecond).getDate();
            }
            this.getDataTypeList(year, month, day);
        },
        isWeixins () {
            return isWeiXin()
        },
        // 数据列表页
        async getDataTypeList (year, month, day, tab, cold) {
            const jsons = {};
            const type = this.type;
            let time = this.time;
            this.loading = true
            jsons.type = type;
            if (year && month && day) {
                if (day < 10) {
                    day = "0" + day;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                time = year + "-" + month + "-" + day;
            }
            if (time) {
                jsons.time = time;
            }
            setTitle(mutil.dailyMap[type + '']);
            const data = await getDataTypeListApi(jsons)
            // eslint-disable-next-line eqeqeq
            if (data && data.errno == '0') {
                // eslint-disable-next-line no-redeclare
                var daily = data.data;
                var startTime = "";
                var endTime = "";
                var coldcurTime = "";

                var sTime = new Date(daily.curDate.split('-').join('/')).getTime();
                var cc = new Date().getFullYear() + '/' + (new Date().getMonth() * 1 + 1) + '/' + new Date().getDate();
                var cTime = new Date(cc).getTime();

                var today = new Date();
                var now = [formatDate(today, "yyyy"), formatDate(today, "MM"), formatDate(today, "dd")];
                var todaynow = now[0] + "-" + now[1] + "-" + now[2];
                if (sTime < cTime) {
                    this.isSelect = 1
                // eslint-disable-next-line eqeqeq
                } else if (sTime == cTime) {
                    this.isSelect = 2
                } else {
                    this.isSelect = 3
                }
                if (daily.time) {
                    startTime = daily.time.startTime;
                    endTime = daily.time.endTime;
                } else {
                    startTime = daily.curDate;
                    endTime = todaynow;
                }
                this.today = daily.todayData
                this.tomorrow_num = daily.tomorrowDataNum

                this.current_time = coldcurTime || daily.curDate
                this.daytxt = daily.day

                this.startTime = startTime
                this.endTime = endTime
                this.coldtime = startTime

                this.buy_info = {
                    total: data.buy_info.total,
                    avatar: data.buy_info.avatar
                }
                this.info = data.info
                this.loading = false
                this.$nextTick(() => {
                    this.svgCircle();
                })
            }
        },
        // 环形图
        svgCircle () {
            // svg
            const donutSvgPath = document.querySelectorAll(".donut__svg__path");
            const donutSvgR = document.querySelectorAll(".donut__svg__r");
            for (var m = 0; m < donutSvgPath.length; m++) {
                const svgPath = donutSvgPath[m];
                const svgR = donutSvgR[m];
                const $path = svgPath.getElementsByTagName("circle");
                for (var n = 0; n < $path.length; n++) {
                    const pathCircle = $path[n];
                    const r = (svgPath.offsetWidth * 1 - svgR.offsetWidth * 1) / 2;
                    const cx = svgPath.offsetWidth * 1 / 2;
                    const cy = svgPath.offsetWidth * 1 / 2;
                    pathCircle.setAttribute("r", r);
                    pathCircle.setAttribute("cx", cx);
                    pathCircle.setAttribute("cy", cy);
                    pathCircle.setAttribute("fill", "none");
                    pathCircle.setAttribute("stroke-width", svgR.offsetWidth * 1);
                    // eslint-disable-next-line eqeqeq
                    if (n == 1) {
                        const perimeter = 2 * Math.PI * r;
                        const rangeValue = pathCircle.getAttribute("data-percent") * 1;
                        const radio = perimeter - (rangeValue / 100) * perimeter
                        pathCircle.style.strokeDasharray = pathCircle.style.strokeDashoffset = perimeter;
                        pathCircle.style.transition = "stroke-dashoffset 600ms ease-in-out";
                        pathCircle.style.strokeDashoffset = radio;
                    }
                }
            }
        }
    }
}
</script>

<style>
@import url("../../assets/css/_discovery.min.css");
</style>
